export default __webpack_public_path__ + "static/media/gama-servicios-financieros-aud24.651dcd8d.pdf";